import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/split-button/split-button.js';
      import {ContextMenuOption, ContextMenuType, ColumnGroup} from '@oicl/openbridge-webcomponents/dist/components/context-menu-input/context-menu-input.js';

      export interface Props {
     label?: string;
     hasIcon?: boolean;
     options?: ContextMenuOption[];
     selectedValues?: string[];
     menuType?: ContextMenuType;
     multiSelect?: boolean | undefined;
     selectPerGroup?: boolean | undefined;
     itemsPerColumn?: number;
     hasTitleBar?: boolean;
     menuTitle?: string;
     fullWidth?: boolean;
     disabled?: boolean;
     openTop?: boolean;
     columnGroups?: ColumnGroup[]
   }

      
  
      export type {ContextMenuOption, ContextMenuType, ColumnGroup} from '@oicl/openbridge-webcomponents/dist/components/context-menu-input/context-menu-input.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcSplitButton',
  props: {
    label: {},
    hasIcon: { type: Boolean },
    options: {},
    selectedValues: {},
    menuType: {},
    multiSelect: { type: Boolean },
    selectPerGroup: { type: Boolean },
    itemsPerColumn: {},
    hasTitleBar: { type: Boolean },
    menuTitle: {},
    fullWidth: { type: Boolean },
    disabled: { type: Boolean },
    openTop: { type: Boolean },
    columnGroups: {}
  },
  emits: ["click", "change"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onClick: (event: CustomEvent<{action: 'primary' | 'dropdown', value?: string, option?: ContextMenuOption}>) => emit('click', event as CustomEvent<{action: 'primary' | 'dropdown', value?: string, option?: ContextMenuOption}>),
onChange: (event: CustomEvent<{selectedValues: string[], selectedOptions: Array<ContextMenuOption>}>) => emit('change', event as CustomEvent<{selectedValues: string[], selectedOptions: Array<ContextMenuOption>}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-split-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})